export const getUserData = (val) => {
    const data = JSON.parse(localStorage.getItem('user_details'))
    if (data) {
        return data[val]
    }
}

export const getToken = () => {
    const data = localStorage.getItem('access_token')
    if (data) {
        return data
    }
}